import { LinearProgress, makeStyles } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import {
	Datagrid,
	DatagridBody,
	List as RaList,
	Pagination,
	TextField,
	useQueryWithStore,
} from "react-admin";
import { DATE_RANGE_EXPR } from "../components/inputs/DateRangeInput";
import { useDatagridStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import DatagridRow from "./DatagridRow";
import DatagridRowExpanded from "./DatagridRowExpanded";
import DateField from "./fields/DateField";
import EventField from "./fields/EventField";
import Filters from "./Filters";

const useListStyles = makeStyles(
	(theme) => ({
		// rowEven: { backgroundColor: red[500] },
		main: {
			"& table td, table th": {
				whiteSpace: "nowrap",
			},
		},
		[theme.breakpoints.down("sm")]: {
			main: (props) => ({
				maxWidth: "100vw",
				overflowX: "auto",
				marginTop: "1em",
				// background: theme.palette.background.default,
			}),
			content: {
				// background: theme.palette.background.default,
				boxShadow: "none",
			},
		},
	}),
	{ name: "RaStatsList" }
);

const DesktopList = ({ permissions, events, ...props }) => {
	const classes = useDatagridStyles();
	const hasUserIdFilter = get(props.filterValues, "user_id");
	const isInsights = permissions && permissions("insights");
	const isUser = permissions && permissions("user");
	const getSource = () => {
		if (isInsights && !hasUserIdFilter) {
			return "user";
		} else if (isUser || hasUserIdFilter) {
			return "bookmaker";
		}
		return "user";
	};
	return (
		<Datagrid
			{...props}
			classes={classes}
			body={<DatagridBody row={<DatagridRow />} />}
			expand={
				<DatagridRowExpanded
					filterValues={get(props, "filterValues")}
					permissions={permissions}
					events={events}
				/>
			}
		>
			<TextField
				source={getSource()}
				style={{ fontWeight: "bold", width: "10%" }}
			/>
			{isUser && !isInsights && (
				<DateField source="sync_last_stats_update" showTime emptyText="-" />
			)}
			{events.map((event) => (
				<EventField key={event.id} source={event.name} event={event} />
			))}
		</Datagrid>
	);
};

const List = (props) => {
	const today = DATE_RANGE_EXPR.today();
	const { data } = useQueryWithStore({
		type: "getList",
		resource: "events",
		payload: {
			sort: { field: "order", order: "ASC" },
			pagination: {
				page: 1,
				perPage: 100,
			},
			filter: {
				user: true,
			},
		},
	});
	const classes = useListStyles();
	const { permissions } = props;
	if (typeof permissions !== "function") {
		return <LinearProgress />;
	}
	const isInsights = permissions && permissions("insights");
	const isUser = permissions && permissions("user");
	return (
		<RaList
			{...props}
			classes={classes}
			perPage={perPage(50, 100)}
			filters={<Filters permissions={props.permissions || ((role) => false)} />}
			pagination={
				<Pagination
					rowsPerPageOptions={[10, 25, 50, 100, 200, 250, 500, 1000]}
				/>
			}
			bulkActionButtons={false}
			sort={{
				field: isUser && !isInsights ? "bookmaker" : "user",
				order: "ASC",
			}}
			filterDefaultValues={{
				view: "today",
				start_at: today.start_at,
				end_at: today.end_at,
			}}
			title="resources.stats.name"
			exporter={false}
			actions={<Actions permissions={permissions} />}
		>
			<DesktopList
				events={
					data
						? data.filter(
								(e) =>
									(permissions && permissions("user") && e.code !== "REV") ||
									(permissions && permissions("admin"))
						  )
						: []
				}
				permissions={props.permissions || ((role) => false)}
			/>
		</RaList>
	);
};
export default List;
